module.exports = __webpack_public_path__ + "static/img/27.c95c319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/27.png
// module id = lg+A
// module chunks = 0